<template>
	<div>
		<div class="custom-splash" v-show="animate === true">
			<div id="splash_cont" class="animate">
				<svg height="400" width="400" xmlns="http://www.w3.org/2000/svg">
					<circle class="circle" cx="200" cy="200" r="195"></circle>
				</svg>
				<img id="ruby" src="img/sre_vert.svg" alt="" width="65%"/>
			</div>
		</div>

		<el-container
				class="main-container"
				v-loading.fullscreen.lock="status"
				:element-loading-text="message"
				element-loading-background="rgba(255, 255, 255, 0.75)"
				:class="{ 'blur': animate === true }">
			<vue-progress-bar></vue-progress-bar>
			<el-header id="?" :class="{
			           'el-header-el-salvador': isSalvadorProgram(),
			           'el-header-honduras': isHondurasProgram() }">

				<el-row>
					<el-col :span="6"
					        :offset="6"
					        class="image-frame"
					        align="center">

						<el-image fit="fill"
						          @click="toInit()"
						          class="hover-button"
						          :src="logos.img1"
						          style="width: 150px; margin-left: -60px;"
						          width="150px">
							<div slot="error" class="image-slot">
								<i class="el-icon-picture-outline"></i>
							</div>
						</el-image>


					</el-col>

					<el-col :span="10"
					        :offset="2"

					        class="image-frame"
					        align="end">
						<el-image fit="fill"
						          @click="toInit()"
						          class="image-center hover-button"
						          :src="logos.img3"
						          style="width: 400px;"
						          width="400px">
							<div slot="error" class="image-slot">
								<i class="el-icon-picture-outline"></i>
							</div>
						</el-image>
					</el-col>
				</el-row>
			</el-header>

			<div>

				<el-row style="border-bottom: 1px solid #c4c4c4;color: #fff"
				        :class="{
			           'sub-header-el-salvador': isSalvadorProgram(),
			           'sub-header-honduras': isHondurasProgram()}"
				        v-if="isAuth">
					<el-col align="end">
						<el-menu
								:router="true"
								mode="horizontal"
								background-color="inherit"
								text-color="#fff"
								active-text-color="#fff">
							<el-menu-item
									class="border-menu-item"
									@click="logout"
									style="cursor:pointer;float: right;">
								<i class="fas fa-sign-out-alt" style="color: #fff"></i>
								<span>
							Cerrar sesión
							</span>
							</el-menu-item>
							<el-menu-item
									class="border-menu-item"
									style="cursor:pointer;float: right">
								<i class="fas fa-user" style="color: #fff"></i>
								<span>
								{{ userEmail }}
							</span>
							</el-menu-item>
						</el-menu>
					</el-col>
				</el-row>


				<el-row>
					<el-col :span="24"
					        align="center">
						<div style="background-color: #fdf8e2;">

							<el-image fit="fill"
							          @click="$router.push('/')"
							          class="image-center hover-button"
							          src="/img/young.png"
							          style="width: 150px;"
							          width="150px">
								<div slot="error" class="image-slot">
									<i class="el-icon-picture-outline"></i>
								</div>
							</el-image>

						</div>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<main :class="{
			           'content-wrapper': !showParalax,
			           'custom-main': !showParalax }"
						      id="body-content">
							<div
									style="background: #fff"
									:class="{
				         'custom-top': !showParalax,
			           'el-card': !showParalax,
			           'is-never-shadow': !showParalax }">
								<div :class="{'el-card__body': !showParalax }">
									<router-view></router-view>
								</div>
							</div>
						</main>
					</el-col>
				</el-row>
			</div>
		</el-container>
	</div>
</template>

<script>

    import programMixin from '@/mixins/programMixin';

	import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
	import ElContainer from "element-ui/packages/container/src/main";
	import CustomFooter from "@/components/partials/CustomFooter";

	const first = _ => {
		return {
			header: 1,
			img1: '/img/logoheader.svg',
			img2: '/img/young2.png',
			img3: '/img/sre-logo.png'
		}
	};
	const second = _ => {
		return {
			header: 2,
			img1: '/img/gobierno.png',
			img2: '/img/logo.png',
			img3: '/img/sre_vert.svg'
		}
	};
	export default {
		components: {ElContainer, CustomFooter},
        mixins:[programMixin],
		data() {
			return {
				showParalax: false,
				show: false,
				animate: false,
				showStatus: false,
				logos: first(),
			};
		},
		computed: {
			...mapState(["route"]),
			...mapGetters("loading", ["message", "status"]),
			...mapGetters(["userFullName", "cat_profile_id", "isAuth", "userEmail"]),
		},
		methods: {

			toInit() {
				window.location.href = "/";
			},
			init() {

				this.showParalax = !!(this.route && this.route.name && (this.route.name == 'Landing'));
				//Splash
				if (!window.sessionStorage.getItem('young_splash')) {
					this.animate = true;
					setTimeout(() => {
						this.animate = false;
					}, 2100);
					window.sessionStorage.setItem('young_splash', 1);
				}
			},
			logout() {

				let _this = this;
				this.$confirm('¿Desea cerrar su sesión? Antes asegúrese de guardar todos sus cambios.', 'Alerta', {
					confirmButtonText: 'Cerrar sesión',
					cancelButtonText: 'Cancelar',
					type: 'warning'
				}).then(() => {
					this.$store
						.dispatch("setLogOut")
						.then(res => {
							setTimeout(() => {
								location.reload();
							}, 500);
						})
						.catch(error => {
							console.log("error:", error);
						});

				}).catch(() => {
					this.$message({
						type: 'info',
						message: 'Cancelado'
					});
				});

			}
		},
		created() {
			this.init();
		},
		watch: {
			$route: 'init',
		},
	}
</script>

<style>
	.el-menu-item {
		border-bottom: none !important;
		height: 35px !important;
		line-height: 35px !important;
	}

	.el-menu-item:focus, .el-menu-item:hover {
		outline: 0;
		background-color: rgba(0, 0, 0, 0.2) !important;
	}

	.el-menu-item.border-menu-item.is-active {
		border-color: rgba(0, 0, 0, 0.1) !important;
		color: #fff;
	}
</style>

<style>
	.hover-button, .hover-button:hover {
		cursor: pointer;
	}

	.custom-main {
		display: block;
		-webkit-box-flex: 1;
		-ms-flex: 1;
		flex: 1;
		-ms-flex-preferred-size: auto;
		flex-basis: auto;
		/*overflow: auto;*/
		box-sizing: border-box;
		padding: 20px;

	}

	.image-frame {
		display: flex;
		align-items: center;
		height: 90px;
	}

	.image-center {
		display: block;
		margin: 0 auto;
	}

	/* Content wrapper */
	.content-wrapper {
		background-image: url(/img/sre_white.png);

		background-repeat: no-repeat;
		background-size: cover;
		width: 100% !important;
		/*overflow: auto;*/
		height: 100%;
		min-height: 87vh !important;
	}

	.header-title-home {
		font-size: 14px;
		color: rgb(255, 255, 255);
		text-align: center;
	}

	.el-button {

		border-bottom-right-radius: 0px;
		border-bottom-left-radius: 0px;
		border-bottom: none;
		box-shadow: none;
		font-weight: bold;

	}

	.logo-sre2 {
		background-size: contain;
		height: 40px;
		width: 100px;
		overflow: hidden;
		margin-top: 10px;
		margin-left: 5px;
	}

	.bannerMain {
		background-repeat: no-repeat;
		background-size: cover;
		width: 100% !important;
	}

	.main-container {
		/*height: 100vh !important;
		width: 100%;
		overflow: auto;*/
	}

	/*@media screen and ( min-height: 768px ) {
		.el-container {
			height: 768px
		}
	}

	@media screen and ( min-height: 896px ) {
		.el-container {
			height: 896px
		}
	}

	@media screen and ( min-height: 912px ) {
		.el-container {
			height: 912px
		}
	}

	@media screen and ( min-height: 1024px ) {
		.el-container {
			height: 1024px
		}
	}

	@media screen and ( min-height: 1180px ) {
		.el-container {
			height: 1180px
		}
	}

	@media screen and ( min-height: 1280px ) {
		.el-container {
			height: 1280px
		}
	}*/

	/*@media screen and ( min-height: 768px ) {

		.main-container {

			min-height: 768px
		}
	}

	@media screen and ( min-height: 896px ) {

		.main-container {

			min-height: 896px
		}
	}

	@media screen and ( min-height: 912px ) {

		.main-container {

			min-height: 912px
		}
	}

	@media screen and ( min-height: 1024px ) {

		.main-container {

			min-height: 1024px
		}
	}

	@media screen and ( min-height: 1180px ) {
		.main-container {

			min-height: 1180px
		}
	}

	@media screen and ( min-height: 1280px ) {

		.main-container {

			min-height: 1280px
		}
	}*/

	.el-menu-item {

		border-bottom: none !important;
	}

	.el-menu-item:focus, .el-menu-item:hover {
		outline: 0;
		background-color: rgba(0, 0, 0, 0.2) !important;
	}

	.el-menu-item.border-menu-item.is-active {
		border-color: rgba(0, 0, 0, 0.1) !important;
	}

	.wabble-effect:nth-child(2n) {
		animation: keyframes1;
		animation-iteration-count: infinite;
		transform-origin: 50% 10%;
		animation-delay: -0.75s;
		animation-duration: .25s
	}

	.wabble-effect:nth-child(2n-1) {
		animation-name: keyframes2;
		animation-iteration-count: infinite;
		animation-direction: alternate;
		transform-origin: 30% 5%;
		animation-delay: -0.75s;
		animation-duration: .25s
	}

	@keyframes keyframes1 {
		0% {
			transform: rotate(-1deg);
			animation-timing-function: ease-in;
		}
		50% {
			transform: rotate(1.5deg);
			animation-timing-function: ease-out;
		}
	}

	@keyframes keyframes2 {
		0% {
			transform: rotate(1deg);
			animation-timing-function: ease-in;
		}
		50% {
			transform: rotate(-1.5deg);
			animation-timing-function: ease-out;
		}
	}

	.blur {
		background: #fff;
		-webkit-filter: blur(5px);
		-moz-filter: blur(5px);
		-o-filter: blur(5px);
		-ms-filter: blur(5px);
		filter: blur(5px);
	}

	.custom-splash {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;

		z-index: 9999;

	}

	#splash_cont {
		background: rgba(255, 255, 255, 0.52);
		position: relative;
		z-index: 9999999;
	}

	#splash_cont.animate {

		height: 400px;
		width: 400px;
		position: relative;
		border-radius: 50%;
		margin: 0 auto;
		top: 45%;
		-webkit-transform: translateY(-50%);
		transform: translateY(-50%);
		-webkit-animation: move-ruby 0.7s ease 2.4s forwards;
		animation: move-ruby 0.7s ease 2.4s forwards;
	}

	#splash_cont.animate #ruby {
		position: absolute;
		top: 125px;
		left: 64.5px;
		-webkit-transform: scale(0);
		transform: scale(0);
		-webkit-animation: scale-ruby 0.48s ease 0s forwards;
		animation: scale-ruby 0.48s ease 0s forwards;
	}

	#splash_cont.animate .circle {
		fill: rgba(254, 82, 79, 0);
		stroke: rgba(254, 82, 79, 0);
		stroke-width: 4;
		stroke-dasharray: 1228;
		stroke-dashoffset: 0;
		-webkit-transform-origin: 50% 50%;
		transform-origin: 50% 50%;
		-webkit-transform: rotate(-90deg);
		transform: rotate(-90deg);
		-webkit-animation: animate-ruby-circle 1.3s ease 0.3s forwards;
		animation: animate-ruby-circle 1.3s ease 0.3s forwards;
	}

	#splash_cont.animate #splash_title {
		text-align: center;
		font-weight: 500;
		font-size: 1.75em;
		color: rgba(80, 80, 80, 0);
		-webkit-animation: splash_title 1.2s ease 1.2s forwards;
		animation: splash_title 1.2s ease 1.2s forwards;
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		-webkit-transform: translateY(150%);
		transform: translateY(150%);
	}

	@-webkit-keyframes scale-ruby {
		0% {
			-webkit-transform: scale(0);
			transform: scale(0);
			top: 125px;
		}
		60% {
			-webkit-transform: scale(1.25);
			transform: scale(1.25);
			top: 120px;
		}
		100% {
			-webkit-transform: scale(1);
			transform: scale(1);
			top: 125px;
		}
	}

	@keyframes scale-ruby {
		0% {
			-webkit-transform: scale(0);
			transform: scale(0);
			top: 125px;
		}
		60% {
			-webkit-transform: scale(1.25);
			transform: scale(1.25);
			top: 120px;
		}
		100% {
			-webkit-transform: scale(1);
			transform: scale(1);
			top: 125px;
		}
	}

	@-webkit-keyframes animate-ruby-circle {
		0% {
			stroke-dashoffset: 1228;
			stroke: #dfcdb2;
		}
		70% {
			stroke: #c9af8d;
			stroke-width: 4;
		}
		90% {
			stroke-dashoffset: 0;
		}
		100% {
			stroke-dashoffset: 0;
			stroke: #dec4a1;
			stroke-width: 10;
		}
	}

	@keyframes animate-ruby-circle {
		0% {
			stroke-dashoffset: 1228;
			stroke: #dfcdb2;
		}
		70% {
			stroke: #c9af8d;
			stroke-width: 4;
		}
		90% {
			stroke-dashoffset: 0;
		}
		100% {
			stroke-dashoffset: 0;
			stroke: #dec4a1;
			stroke-width: 10;
		}
	}

	@-webkit-keyframes splash_title {
		0% {
			color: rgba(80, 80, 80, 0);
		}
		18% {
			color: #505050;
		}
		65% {
			color: #505050;
		}
		100% {
			color: rgba(80, 80, 80, 0);
		}
	}

	@keyframes splash_title {
		0% {
			color: rgba(80, 80, 80, 0);
		}
		18% {
			color: #505050;
		}
		65% {
			color: #505050;
		}
		100% {
			color: rgba(80, 80, 80, 0);
		}
	}

	@-webkit-keyframes move-ruby {
		0% {
			opacity: 1;
			top: 45%;
			-webkit-transform: scale(1) translateY(-50%);
			transform: scale(1) translateY(-50%);
		}
		20% {
			opacity: 1;
		}
		100% {
			opacity: 0;
			top: 35%;
			-webkit-transform: scale(0.01) translateY(-280%);
			transform: scale(0.01) translateY(-280%);
		}
	}

	@keyframes move-ruby {
		0% {
			opacity: 1;
			top: 45%;
			-webkit-transform: scale(1) translateY(-50%);
			transform: scale(1) translateY(-50%);
		}
		20% {
			opacity: 1;
		}
		100% {
			opacity: 0;
			top: 35%;
			-webkit-transform: scale(0.01) translateY(-280%);
			transform: scale(0.01) translateY(-280%);
		}
	}
</style>
